var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"LlW5XjUy1hOM9mdOFw92E"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["pnthn-client@pnthn"]={id:"LlW5XjUy1hOM9mdOFw92E"};
      